<template>
    <nav class="bg-white border-b border-gray-200">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="flex h-14 items-center justify-between">
                <div class="flex items-center">
                    <div class="shrink-0">
                        <a :href="RoutePathAppEnum.Root">
                            <AppLogo :appName="appName" />
                        </a>
                    </div>
                    <div class="hidden md:block">
                        <div class="ml-10 flex items-baseline space-x-2">
                            <!-- <a :href="RoutePathAppEnum.Root" class="rounded-lg2 px-3 py-2 text-sm font-medium text-gray-800" :class="{'bg-gray-200': currentRoute === '/', 'hover:bg-gray-200': currentRoute !== '/'}">
                                Dashboard
                            </a> -->
                        </div>
                    </div>
                </div>
                <div class="hidden md:block">
                    <div class="ml-4 flex items-center md:ml-6">
                        <!-- <button type="button" class="rounded-full p-1 text-gray-800 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
                            </svg>
                        </button> -->

                        <ProfileDropdown :customer="authCustomer" />
                    </div>
                </div>
                <div class="-mr-2 flex md:hidden">
                    <!-- Mobile menu button -->
                    <button
                        @click="toggle()"
                        type="button"
                        class="inline-flex items-center justify-center rounded-lg2 p-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
                    >
                        <svg
                            class="block h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                            />
                        </svg>
                        <svg
                            class="hidden h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <!-- Mobile menu, show/hide based on menu state. -->
        <div
            v-if="isOpen"
            class="md:hidden"
            id="mobile-menu"
        >
            <div class="space-y-1 px-2 pb-3 pt-2 sm:px-3">
                <a
                    :href="RoutePathAppEnum.Root"
                    class="block rounded-lg2 px-3 py-2 text-base font-medium text-gray-800"
                    :class="{
                        'bg-gray-200': currentRoute === '/',
                        'hover:bg-gray-200': currentRoute !== '/',
                    }"
                >
                    Dashboard
                </a>
            </div>
            <div class="border-t border-gray-200 pb-3 pt-4">
                <div class="flex items-center px-5">
                    <div class="shrink-0">
                        <!-- <Image class="h-10 w-10 rounded-full" :src="authCustomer.profilePictureUrl ? authCustomer.profilePictureUrl : '/static/images/profile.png'" alt=""> -->
                        <Image
                            class="h-10 w-10 rounded-full"
                            src="/static/images/profile.png"
                            alt=""
                        />
                    </div>
                    <div class="ml-3 space-y-1">
                        <div
                            class="text-base font-medium leading-none text-gray-700"
                        >
                            {{ authCustomer.firstName }}
                            {{ authCustomer.lastName }}
                        </div>
                        <div
                            class="text-sm font-medium leading-none text-gray-500"
                        >
                            {{ authCustomer.email }}
                        </div>
                    </div>
                    <!-- <button type="button" class="ml-auto shrink-0 rounded-full bg-gray-200 p-1 text-gray-800 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                        <span class="sr-only">View notifications</span>
                            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
                        </svg>
                    </button> -->
                </div>
                <div class="mt-3 space-y-1 px-2">
                    <!-- <a :href="RoutePathAppEnum.Company" class="block rounded-lg2 px-3 py-2 text-base font-medium text-gray-800" :class="{'bg-gray-200': currentRoute.startsWith('/my-account'), 'hover:bg-gray-200': !currentRoute.startsWith('/my-account')}">
                        My Company
                    </a> -->
                    <form
                        :action="RoutePathAppEnum.Auth_Logout"
                        method="POST"
                        id="logout-form"
                    ></form>
                    <button
                        form="logout-form"
                        type="submit"
                        class="block w-full text-left rounded-lg2 px-3 py-2 text-base font-medium text-gray-800 hover:bg-gray-200"
                    >
                        Logout
                    </button>
                </div>
            </div>
        </div>
    </nav>
</template>

<script setup lang="ts">
    // TODO: Create components for menu items for example

    import { ref } from 'vue'
    import AppLogo from '@/Shared/Component/AppLogo.vue'
    import ProfileDropdown from '@/Shared/Layout/Customer/ProfileDropdown.vue'
    import Customer from '@/App/Customer/Entity/Customer'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'
    import Image from '@/Shared/Component/Image.vue'

    interface AppMobileTopbarProps {
        appName: string
        authCustomer: Customer
        currentRoute: string
    }

    const props = defineProps<AppMobileTopbarProps>()
    const isOpen = ref<boolean>(false)

    const toggle = function () {
        isOpen.value = !isOpen.value
    }
</script>
